module.exports = __webpack_public_path__ + "img/11.e0297ab9.jpg";